import type { User } from '@relyo/protocol';

export type RelyoUser = User;

/**
 * Startposition der Status-Pille während einer Session (Issue #9). Der Nutzer kann sie an eine
 * andere Stelle ziehen; das merkt sich das SDK pro Browser.
 */
export type StatusPosition =
  'bottom' | 'bottom-left' | 'bottom-right' | 'top' | 'top-left' | 'top-right';

export const STATUS_POSITIONS: readonly StatusPosition[] = [
  'bottom',
  'bottom-left',
  'bottom-right',
  'top',
  'top-left',
  'top-right',
];

/** Verbindungsmodus (Spec Kap. 5 Punkt 1). */
export type ConnectMode = 'auto' | 'eager' | 'lazy';

export interface RelyoOptions {
  /** Basis-URL des Relay, z. B. `wss://relyo.de` (http/https wird zu ws/wss umgeschrieben). */
  relayUrl: string;
  /**
   * Öffentlicher Projekt-Key aus `projects.json` des Relay. Optional: Ohne Key ordnet ein Relay
   * mit offenem Dienst (`OPEN_SERVICE=1`, z. B. relyo.de) die Seite ihrem Origin zu – dann gibt es
   * nur den Code-Flow, keine Geräteliste.
   */
  projectKey?: string | null;
  /** Angemeldeter Nutzer; nur Anzeige, unverifiziert (v1). */
  user?: RelyoUser | null;
  /** Zusätzliche Selektoren, die maskiert und von der Aufzeichnung ausgenommen werden. `.relyo-redact` gilt immer. */
  redactSelector?: string;
  /** Alle Eingaben maskieren (Default `false`: nur sensible Felder). */
  maskAllInputs?: boolean;
  /** Default `'auto'`. */
  connect?: ConnectMode;
  /** v1: nur `'de'`. */
  locale?: 'de';
  /** Ersetzt den Erklärtext im Consent-Dialog. `{agent}` wird durch den Agent-Namen ersetzt. */
  consentText?: string;
  /** Nonce für das `<style>`-Element im Shadow DOM (CSP `style-src 'nonce-…'`). */
  cspNonce?: string;
  /** Version der Host-App, erscheint in der Konsole. */
  appVersion?: string;
  /** Startposition der Status-Pille, Default `'bottom'` (unten mittig). */
  statusPosition?: StatusPosition;
}

export interface ResolvedOptions {
  relayUrl: string;
  /** `null`: offener Dienst ohne Projekt-Key. */
  projectKey: string | null;
  user: RelyoUser | null;
  redactSelector: string;
  maskAllInputs: boolean;
  connect: ConnectMode;
  locale: 'de';
  consentText: string | null;
  cspNonce: string | null;
  appVersion: string;
  statusPosition: StatusPosition;
}
